// Petit point d'accès à l'API globale `google` injectée par le script
// Google Identity Services (chargé dynamiquement par `@react-oauth/google`
// via <GoogleOAuthProvider>). Le flux de connexion lui-même est déclenché
// par le bouton officiel Google rendu dans GoogleOAuthButton — ce service
// centralise seulement les interactions ponctuelles avec `window.google`
// pour garder ce détail d'implémentation hors des composants React.

declare global {
  interface Window {
    google?: {
      accounts?: {
        id?: {
          disableAutoSelect: () => void;
        };
      };
    };
  }
}

/**
 * Désactive la resélection automatique du compte Google au prochain chargement.
 *
 * Sans cet appel, Google Identity Services peut re-proposer silencieusement
 * le dernier compte connecté (One Tap / sélection automatique) après une
 * déconnexion explicite côté SolarCells. Sans effet si le script GIS n'a
 * pas encore chargé `window.google` (ex: déconnexion avant tout affichage
 * du bouton de connexion) — l'accès optionnel ci-dessous gère ce cas.
 */
export function disableGoogleAutoSelect(): void {
  window.google?.accounts?.id?.disableAutoSelect();
}
